<template>
    <div style="padding: 10px">
      <h1 class="center"> Login into account </h1>
      <el-form>
      <el-form-item label="Phone Number">
        <el-input type="number" minlength="10" maxlength="11" v-model="credentials.username">
           <template slot="prepend">+234</template>
        </el-input>
      </el-form-item>

      <el-form-item label="Password">
        <el-input type="password" v-model="credentials.password"/>
      </el-form-item>
        <el-button :loading="loading" @click="handleLogin"  style="width: 100%;" type="warning">Login</el-button>
    </el-form>
    </div>
</template>

<script>
import { login, storeAuthentication } from '@/services/auth'
// TODO export this as a constant
const USER_TYPE = ['admin', 'sales_rep', 'drivers']
export default {
  name: 'SignIn',
  data () {
    return {
      credentials: {
        username: '',
        password: ''
      },
      loading: false
    }
  },

  methods: {
    // TODO validate phone number so user pass the right number
    handleLogin (event) {
      this.loading = true
      login(this.credentials)
        .then((success) => {
          const { user, token } = success.data
          storeAuthentication(this.credentials, token, user)
          this.loading = false
          if (user.is_superuser) {
            this.$router.push({ name: 'Passengers' })
          } else if (USER_TYPE.includes(user.user_type)) {
            // for other users just redirect them to the mobile page
            this.$router.push({ name: 'MobileMenu' })
          } else {
            this.$router.push({ name: 'Home' })
          }
        }).catch(error => {
          this.$message.error({
            message: error.response.data
          })
          this.loginError = 'Username or password incorrect'
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue